import React, { useState, useRef, useEffect } from "react";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import { InputText } from "primereact/inputtext";
import { updateTransactionRequest } from "../common/customServiceCall/serviceCall";
import { Toast } from "primereact/toast";
import { useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { ProgressSpinner } from "primereact/progressspinner";
import { Calendar } from "primereact/calendar";
import ReactTooltip from "react-tooltip";
import { TabPanel, TabView } from "primereact/tabview";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useParams } from "react-router-dom";

export const BulkJobs = () => {
  const location = useLocation();
  const params = useParams();

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [status, setStatus] = useState(null);
  const [reqId, setReqId] = useState(null);
  const [transId, setTransId] = useState("");
  const [sysTransId, setSysTransId] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [jobDetails, setJobDetails] = useState(null);
  const jobId = params.id;

  const [isLoading, setIsLoading] = useState(false);
  const toast = useRef(null);

  const userDetails = useSelector((state) => state.login.userDetails);

  const token = userDetails._id;

  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "#999",
    fontWeight: "500",
  };
  const floatLabel = {
    fontWeight: "500",
    color: "rgb(153, 153, 153)",
    fontSize: "12px",
  };

  const statusFilter = [
    { label: "Pending", value: "PENDING" },
    { label: "Processing", value: "PROCESSING" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Cancelled", value: "CANCELLED" },
  ];

  const getSearchedData = () => {
    fetchData();
  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-success p-mr-2"
        onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
      <ReactTooltip id="toolTip1" />
    </>
  );

  const handleViewModalDisplay = (rowData) => {
    setTransactionData(rowData);
    setShowUploadModal(true);
  };

  const getJobDetails = async () => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append("job_id", jobId);
    formData.append("token", token);

    try {
      const response = await updateTransactionRequest(
        "post",
        "/completion/bulk/jobs/get",
        formData
      );

      if (response.code !== 200) {
        setJobDetails(response.data || {});
      } else {
        setJobDetails({});
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("token", token);
    formData.append("job_id", jobId ? jobId : "");
    formData.append("start_date", dateRange ? dateRange.startDate : "");
    formData.append("end_date", dateRange ? dateRange.endDate : "");
    formData.append("request_id", reqId ? reqId : "");
    formData.append("status", status ? status : "");
    formData.append("transaction_system_id", sysTransId);
    formData.append("transaction_pay_id", transId);
    formData.append("page", 1);
    formData.append("size", 50);

    try {
      const response = await updateTransactionRequest(
        "post",
        "/completion/bulk/transactions/filter",
        formData
      );
      if (response.code !== 200) {
        setTransactionData(response.data || []);
      } else {
        setTransactionData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    getJobDetails();
  }, [dateRange]);

  useEffect(() => {
    if (location.state?.jobId) {
      console.log("Job ID available now:", location.state.jobId);
    }
  }, [location.state]);

  return (
    <>
      <section
        className="p-my-4 p-md-12 p-xl-12"
        style={{ padding: "0px 10%" }}
      >
        <div className="p-col-12 p-md-12 p-xl-12">
          <div className="p-grid p-fluid">
            <div
              className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
              style={{ textAlign: "center" }}
            >
              <span className="p-tag custom-heading">
                Bulk Transaction Completion Job Details
              </span>
            </div>
          </div>
        </div>
        <TabView
          className=""
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="Job Information ">
            <div>
              <div className="card" style={{ paddingTop: "0px" }}>
                <div
                  className="p-grid p-align-center p-justify-center p-fluid"
                  style={{ paddingTop: "10px" }}
                >
                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Job ID:</label>
                    <InputText
                      value={jobDetails?.id || ""}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6 ">
                    <label style={labelStyle}>Request Type:</label>
                    <InputText
                      value={jobDetails?.request_type || ""}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>File Name:</label>
                    <InputText
                      value={jobDetails?.file_name || ""}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>File Size:</label>
                    <InputText
                      value={jobDetails?.file_size || ""}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Status:</label>
                    <InputText
                      value={jobDetails?.status || ""}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Created By:</label>
                    <InputText
                      value={jobDetails?.created_by_name || ""}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  {/* counts */}
                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Total Count:</label>
                    <InputText
                      value={jobDetails?.total_count || ""}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Requeued Count:</label>
                    <InputText
                      value={jobDetails?.requeued_count}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Processing Count:</label>
                    <InputText
                      value={jobDetails?.processing_count}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Success Count:</label>
                    <InputText
                      value={jobDetails?.success_count}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Failure Count:</label>
                    <InputText
                      value={jobDetails?.failure_count}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Started At:</label>
                    <InputText
                      value={jobDetails?.started_at || "N/A"}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className=" p-col-12 p-md-6">
                    <label style={labelStyle}>Completed At:</label>
                    <InputText
                      value={jobDetails?.completed_at || "N/A"}
                      readOnly
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Job Transactions">
            <div>
              <div className="card" style={{ paddingTop: "0px" }}>
                <div
                  className="p-grid p-align-center p-justify-center p-fluid"
                  style={{ paddingTop: "10px" }}
                >
                  {/* Date Range Picker */}
                  <div className=" p-col-12 p-md-3">
                    <label style={floatLabel}>DATE RANGE</label>
                    <span className="p-float-label">
                      <Calendar
                        value={dateRange}
                        onChange={(e) => setDateRange(e.value)} // Set date range
                        selectionMode="range"
                        readOnlyInput
                        showIcon
                        placeholder="Select Date Range"
                      />
                    </span>
                  </div>

                  {/* Status Dropdown */}
                  <div className=" p-col-12 p-md-2 ">
                    <label style={floatLabel}>STATUS</label>
                    <span className="p-float-label">
                      <Dropdown
                        value={status}
                        options={statusFilter}
                        onChange={(e) => setStatus(e.value)}
                        placeholder="Select Status"
                      />
                    </span>
                  </div>

                  {/* Search Input */}
                  <div className=" p-col-12 p-md-2">
                    <label style={floatLabel}>TRANSACTION ID</label>
                    <div className="p-inputgroup">
                      <InputText
                        value={transId}
                        onChange={(e) => setTransId(e.target.value)}
                        placeholder="Enter transId"
                      />
                    </div>
                  </div>

                  <div className=" p-col-12 p-md-2">
                    <label style={floatLabel}>SYSTEM TRANSACTION ID</label>
                    <div className="p-inputgroup">
                      <InputText
                        value={sysTransId}
                        onChange={(e) => setSysTransId(e.target.value)}
                        placeholder="Enter sysTransId"
                      />
                    </div>
                  </div>
                  <div className=" p-col-12 p-md-2">
                    <label style={floatLabel}>REQUEST ID</label>
                    <div className="p-inputgroup">
                      <InputText
                        value={reqId}
                        onChange={(e) => setReqId(e.target.value)}
                        placeholder="Enter Request ID"
                      />
                    </div>
                  </div>
                  <div className=" p-col-12 p-md-1">
                    <Button
                      onClick={getSearchedData}
                      icon="pi pi-search"
                      className="p-button-info"
                      style={{ marginTop: "20px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="card">
                {loading ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <ProgressSpinner
                      style={{
                        display: userDetails.showLoader,
                        width: "40px",
                        height: "40px",
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        bottom: "50%",
                        right: "50%",
                        zIndex: "1111111111",
                      }}
                      strokeWidth="3"
                      animationDuration=".5s"
                    />
                  </div>
                ) : (
                  <DataTable
                    value={transactionData}
                    paginator
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    tableStyle={{ minWidth: "60rem" }}
                    className="p-datatable-responsive-demo"
                  >
                    <Column
                      field="transaction_system_id"
                      header="Transaction System ID"
                      style={{ width: "40%", fontSize: "13px" }}
                    ></Column>
                    <Column
                      field="transaction_pay_id"
                      header="Transaction Pay ID"
                      style={{ width: "35%", fontSize: "13px" }}
                    ></Column>
                    <Column
                      field="status"
                      header="Status"
                      style={{ width: "25%", fontSize: "13px" }}
                    ></Column>

                    <Column
                      field="created_at"
                      header="Created At"
                      style={{ width: "25%", fontSize: "13px" }}
                    ></Column>
                    <Column
                      field="modified_at"
                      header="Modified At"
                      style={{ width: "25%", fontSize: "13px" }}
                    ></Column>
                    <Column
                      header="Actions"
                      style={{ width: "45%", fontSize: "13px" }}
                      body={actions}
                    ></Column>
                  </DataTable>
                )}
              </div>
            </div>
          </TabPanel>
        </TabView>

        <CustomDialog
          visible={showUploadModal}
          header="Transaction Details"
          onClose={() => {
            setShowUploadModal(false);
          }}
        >
          <div className="p-grid p-align-center p-justify-center p-fluid">
            <div className=" p-col-12 p-md-6">
              <label style={labelStyle}>Transaction System ID:</label>
              <InputText
                value={transactionData?.transaction_system_id || ""}
                readOnly
                style={{ width: "100%" }}
              />
            </div>

            <div className=" p-col-12 p-md-6 ">
              <label style={labelStyle}>Transaction Pay ID:</label>
              <InputText
                value={transactionData?.transaction_pay_id || ""}
                readOnly
                style={{ width: "100%" }}
              />
            </div>

            <div className=" p-col-12 p-md-6">
              <label style={labelStyle}>Status:</label>
              <InputText
                value={transactionData?.status || ""}
                readOnly
                style={{ width: "100%" }}
              />
            </div>

            <div className=" p-col-12 p-md-6">
              <label style={labelStyle}>Created At:</label>
              <InputText
                value={transactionData?.created_at || ""}
                readOnly
                style={{ width: "100%" }}
              />
            </div>

            <div className=" p-col-12 p-md-6">
              <label style={labelStyle}>Modified At:</label>
              <InputText
                value={transactionData?.modified_at || ""}
                readOnly
                style={{ width: "100%" }}
              />
            </div>

            <div className=" p-col-12 ">
              <label style={labelStyle}>Failure Reason:</label>
              <p
                style={{
                  width: "100%",
                  fontSize: "12px",
                  color: "#999",
                  fontWeight: "500",
                  paddingLeft: "10px",
                }}
              >
                {transactionData?.error_message || "N/A"}{" "}
              </p>
            </div>
          </div>
        </CustomDialog>
        <Toast ref={toast} />
      </section>
    </>
  );
};
